import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Box } from '../Box/index.js';
import { Text } from '../Text/Text.js';

var SelectLegacyDropdownOption = function (props) {
    var option = props.option, decor = props.decor, icon = props.icon, forwardProps = __rest(props, ["option", "decor", "icon"]);
    var label = option.label, caption = option.caption;
    return (jsxs(Box, __assign({ themeKey: "selectOption" }, forwardProps, { children: [icon && jsx(Box, __assign({ "data-icon": true }, { children: icon })), jsx(Text, __assign({ sx: { gridColumnStart: 2 } }, { children: label })), decor && jsx(Box, __assign({ "data-decor": true }, { children: decor })), caption && (jsx(Text, __assign({ tone: "subtle", sx: { gridColumnStart: 2 }, size: "sm" }, { children: caption })))] })));
};
SelectLegacyDropdownOption.displayName = "SelectLegacyDropdownOption";

export { SelectLegacyDropdownOption };
//# sourceMappingURL=SelectLegacyDropdownOption.js.map
